module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('scroll', {
    ref: "listview",
    staticClass: "listview",
    attrs: {
      "listen-scroll": _vm.listenScroll,
      "probe-type": _vm.probeType,
      "data": _vm.data
    },
    on: {
      "scroll": _vm.scroll
    }
  }, [_c('ul', _vm._l((_vm.data), function(group) {
    return _c('li', {
      ref: "listGroup",
      refInFor: true,
      staticClass: "list-group"
    }, [_c('h2', {
      staticClass: "list-group-title",
      domProps: {
        "innerHTML": _vm._s(group.title)
      }
    }), _vm._v(" "), _c('uL', _vm._l((group.items), function(item) {
      return _c('li', {
        staticClass: "list-group-item",
        on: {
          "click": function($event) {
            _vm.selectItem(item)
          }
        }
      }, [_c('div', {
        staticClass: "name"
      }, [_vm._v(_vm._s(item.name) + "  "), _c('span', {
        staticStyle: {
          "float": "right"
        }
      }, [_vm._v(_vm._s(item.siteName))])])])
    }))], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "list-shortcut",
    on: {
      "touchstart": _vm.onShortcutTouchStart,
      "touchmove": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onShortcutTouchMove($event)
      }
    }
  }, [_c('ul', _vm._l((_vm.shortcutList), function(item, index) {
    return _c('li', {
      staticClass: "item",
      class: {
        'current': _vm.currentIndex === index
      },
      attrs: {
        "data-index": index
      }
    }, [_vm._v(_vm._s(item) + "\n\n            ")])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34238c3c"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/listview.vue
// module id = 395
// module chunks = 1